(function() {
  var dateInput = document.getElementById('delivery-date');
  var timeSelect = document.getElementById('delivery-time');
  var timeContainer = document.getElementById('time-slot-container');
  var weekendWarning = document.getElementById('weekend-warning');
  var confirmation = document.getElementById('delivery-confirmation');
  var confirmationText = document.getElementById('confirmation-text');

  // Festivos oficiales de Chile (hardcoded para mayor confiabilidad)
  // Actualizar manualmente cada año
  var CHILE_HOLIDAYS = {
    2025: [
      '2025-01-01', // Año Nuevo
      '2025-04-18', // Viernes Santo
      '2025-04-19', // Sábado Santo
      '2025-05-01', // Día del Trabajo
      '2025-05-21', // Día de las Glorias Navales
      '2025-06-29', // San Pedro y San Pablo (trasladado al lunes 30)
      '2025-06-30', // San Pedro y San Pablo
      '2025-07-16', // Día de la Virgen del Carmen
      '2025-08-15', // Asunción de la Virgen
      '2025-09-18', // Día de la Independencia
      '2025-09-19', // Día de las Glorias del Ejército
      '2025-10-12', // Día del Encuentro de Dos Mundos (trasladado al lunes 13)
      '2025-10-13', // Día del Encuentro de Dos Mundos
      '2025-10-31', // Día de las Iglesias Evangélicas y Protestantes
      '2025-11-01', // Día de Todos los Santos
      '2025-12-08', // Inmaculada Concepción
      '2025-12-25'  // Navidad
    ],
    2026: [
      '2026-01-01', // Año Nuevo
      '2026-04-03', // Viernes Santo
      '2026-04-04', // Sábado Santo
      '2026-05-01', // Día del Trabajo
      '2026-05-21', // Día de las Glorias Navales
      '2026-06-28', // San Pedro y San Pablo (trasladado al lunes 29)
      '2026-06-29', // San Pedro y San Pablo
      '2026-07-16', // Día de la Virgen del Carmen
      '2026-08-15', // Asunción de la Virgen
      '2026-09-18', // Día de la Independencia
      '2026-09-19', // Día de las Glorias del Ejército
      '2026-10-11', // Día del Encuentro de Dos Mundos (trasladado al lunes 12)
      '2026-10-12', // Día del Encuentro de Dos Mundos
      '2026-10-31', // Día de las Iglesias Evangélicas y Protestantes
      '2026-11-01', // Día de Todos los Santos
      '2026-12-08', // Inmaculada Concepción
      '2026-12-25'  // Navidad
    ]
  };

  // Array para almacenar festivos de Chile
  var chileHolidays = [];

  // Cargar festivos desde lista hardcodeada
  function loadChileHolidays() {
    var now = new Date();
    var currentYear = now.getFullYear();
    var nextYear = currentYear + 1;

    // Cargar festivos del año actual
    if (CHILE_HOLIDAYS[currentYear]) {
      chileHolidays = chileHolidays.concat(CHILE_HOLIDAYS[currentYear]);
    }

    // Si estamos en noviembre o diciembre, cargar también festivos del próximo año
    if (now.getMonth() >= 10 && CHILE_HOLIDAYS[nextYear]) {
      chileHolidays = chileHolidays.concat(CHILE_HOLIDAYS[nextYear]);
    }

    // Eliminar duplicados
    chileHolidays = Array.from(new Set(chileHolidays));

    console.log('Festivos cargados (hardcoded):', chileHolidays.length, 'festivos para', currentYear);

    return Promise.resolve();
  }

  function isHoliday(dateString) {
    return chileHolidays.indexOf(dateString) !== -1;
  }

  function isWeekend(dateString) {
    var date = new Date(dateString + 'T00:00:00');
    var day = date.getDay();
    return day === 0; // Solo bloquea domingos (0 = Domingo)
  }

  function isWeekendOrHoliday(dateString) {
    return isWeekend(dateString) || isHoliday(dateString);
  }

  function getDefaultDate() {
    var now = new Date();
    var currentHour = now.getHours();
    var dateToUse = new Date(now);

    if (currentHour >= 14) {
      dateToUse.setDate(dateToUse.getDate() + 1);
    }

    while (isWeekendOrHoliday(formatDateForInput(dateToUse))) {
      dateToUse.setDate(dateToUse.getDate() + 1);
    }

    return formatDateForInput(dateToUse);
  }

  function formatDateForInput(date) {
    var year = date.getFullYear();
    var month = String(date.getMonth() + 1).padStart(2, '0');
    var day = String(date.getDate()).padStart(2, '0');
    return year + '-' + month + '-' + day;
  }

  function formatDateDisplay(dateString) {
    var months = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
    var date = new Date(dateString + 'T00:00:00');
    return date.getDate() + ' de ' + months[date.getMonth()] + ' de ' + date.getFullYear();
  }

  function updateConfirmation() {
    if (dateInput.value && timeSelect.value && !isWeekendOrHoliday(dateInput.value)) {
      var formattedDate = formatDateDisplay(dateInput.value);
      confirmationText.textContent = 'Entrega programada para el ' + formattedDate + ' entre ' + timeSelect.value.replace('-', ' y ') + ' hrs';
      confirmation.style.display = 'block';
    } else {
      confirmation.style.display = 'none';
    }
  }

  // Cargar festivos primero, luego inicializar
  loadChileHolidays().then(function() {
    var defaultDate = getDefaultDate();
    dateInput.value = defaultDate;
    dateInput.setAttribute('min', defaultDate);

    function setDisabledElement(el, disabled) {
      if (!el) return;
      if (el.tagName.toLowerCase() === 'a') {
        // For links, use pointer events and aria-disabled
        if (disabled) {
          el.setAttribute('aria-disabled', 'true');
          el.classList.add('is-disabled');
          el.style.opacity = '0.6';
          el.style.pointerEvents = 'none';
        } else {
          el.removeAttribute('aria-disabled');
          el.classList.remove('is-disabled');
          el.style.opacity = '';
          el.style.pointerEvents = '';
        }
      } else {
        if (disabled) {
          el.setAttribute('disabled', 'disabled');
          el.classList.add('is-disabled');
          el.style.opacity = '0.6';
          el.style.pointerEvents = 'none';
          el.setAttribute('aria-disabled', 'true');
        } else {
          el.removeAttribute('disabled');
          el.classList.remove('is-disabled');
          el.style.opacity = '';
          el.style.pointerEvents = '';
          el.removeAttribute('aria-disabled');
        }
      }
    }

    function updateCheckoutButtons(enabled) {
      var buttons = document.querySelectorAll('button[name="checkout"], a[href*="/checkout"], .cart__checkout-button, .additional-checkout-buttons button, .additional-checkout-buttons a');
      buttons.forEach(function(btn) { setDisabledElement(btn, !enabled); });
    }

    dateInput.addEventListener('change', function() {
      var selectedDate = this.value;

      if (isWeekendOrHoliday(selectedDate)) {
        weekendWarning.style.display = 'block';
        confirmation.style.display = 'none';
        timeSelect.value = '';
        updateCheckoutButtons(false);
        document.dispatchEvent(new CustomEvent('deliveryDateValidityChanged', { detail: { ok: false } }));
      } else {
        weekendWarning.style.display = 'none';
        updateCheckoutButtons(true);
        document.dispatchEvent(new CustomEvent('deliveryDateValidityChanged', { detail: { ok: true } }));
      }

      updateConfirmation();
    });

    // Ensure checkout buttons reflect the default date validity on load
    (function(){
      var defaultValid = !isWeekendOrHoliday(dateInput.value);
      updateCheckoutButtons(defaultValid);
      document.dispatchEvent(new CustomEvent('deliveryDateValidityChanged', { detail: { ok: defaultValid } }));
    })();

    timeSelect.addEventListener('change', updateConfirmation);
  });

})();
